module.exports = __webpack_public_path__ + "media/images/payment_methods/applepay-fae6f981efafdb659430909755d8a0f8.svg";